const AppModel = {};

AppModel.APP_TITLE = 'SkyCoach';

AppModel.SESSION_COOKIE = process.env.SESSION_COOKIE;

AppModel.HTTP_PROTOCOL = typeof window !== 'undefined'
  ? window.location.protocol
  : process.env.EXPRESS_HTTP_PROTOCOL || 'http:';

if (typeof window !== 'undefined') {
  // клиентская часть
  AppModel.HOSTNAME = window.location.hostname;
  AppModel.INTERNAL_HOSTNAME = window.location.hostname;
} else {
  // серверная часть
  // BACKEND_HOSTNAME_EXTERNAL = skycoach.gg на проде (нужен для нормальной генерации ссылок из-за 127.0.0.1)
  // BACKEND_HOSTNAME = 127.0.0.1 на проде

  // 127.0.0.1 на проде
  AppModel.INTERNAL_HOSTNAME = process.env.BACKEND_HOSTNAME;

  // skycoach.gg на проде
  AppModel.HOSTNAME = process.env.BACKEND_HOSTNAME_EXTERNAL
    ? process.env.BACKEND_HOSTNAME_EXTERNAL
    : process.env.BACKEND_HOSTNAME;
}

AppModel.INTERNAL_URL = `${AppModel.HTTP_PROTOCOL}//${AppModel.INTERNAL_HOSTNAME}`;
AppModel.URL = `${AppModel.HTTP_PROTOCOL}//${AppModel.HOSTNAME}`;

AppModel.API_URN = '/api/shop';

AppModel.API_URI = process.env.BACKEND_HOSTNAME
  ? `${AppModel.INTERNAL_URL}${AppModel.API_URN}`
  : AppModel.API_URN;

export default AppModel;
